var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page)?_c('v-card',{staticClass:"mx-auto"},[_c('v-img',{attrs:{"src":_vm.image,"height":"200px"}}),_c('router-link',{attrs:{"to":'/b/' + _vm.page.nameLink}},[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.page.sections != null && _vm.page.sections[0] != null && _vm.page.sections[0].blocks != null && _vm.page.sections[0].blocks[0] != null ? _vm.page.sections[0].blocks[0].title : "")+" ")])],1),_c('v-card-subtitle',[_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.page.sections != null &&
        _vm.page.sections[0] != null &&
        _vm.page.sections[0].blocks != null &&
        _vm.page.sections[0].blocks[0] != null
          ? _vm.page.sections[0].blocks[0].content
          : ''
      )}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }